// frontend/src/components/TestConnection.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TestConnection = () => {
  const [message, setMessage] = useState('Testing connection...');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('/api/test');
        setMessage(res.data.msg);
      } catch (error) {
        setMessage('Error connecting to backend');
        console.error('Error fetching test endpoint:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <h2>Test Connection</h2>
      <p>{message}</p>
    </div>
  );
};

export default TestConnection;

